var render = function (_h,_vm) {var _c=_vm._c;return _c('button',{staticClass:"inline-edit-link",on:{"click":_vm.listeners['click']}},[_c('i',{staticClass:"fa fa-pencil"})])}
var staticRenderFns = []

export { render, staticRenderFns }